import { render, staticRenderFns } from "./demandInvit.vue?vue&type=template&id=6f7b676a&scoped=true"
import script from "./demandInvit.vue?vue&type=script&lang=js"
export * from "./demandInvit.vue?vue&type=script&lang=js"
import style0 from "./demandInvit.vue?vue&type=style&index=0&id=6f7b676a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7b676a",
  null
  
)

export default component.exports